import axios from 'axios'
import qs from 'qs'

const headers = {
  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
}

export const action = (_action, data = {}) => axios
  .post(
    argus_url.ajax,
    qs.stringify({
      ...data,
      action: _action,
    }),
    headers,
  )
  .then(res => res.data)
  .catch(err => err.data)

export const actionComment = (data = {}) => axios.post(
  `${argus_url.site}/wp-comments-post.php`,
  qs.stringify(data),
)
